import {BaseRepository} from "../../../infrastructure/repositories/base-repository";
import {DomUtils} from "../../../infrastructure/utils/dom-utils";
import {LoggerUtils} from "../../../infrastructure/utils/logger/logger-utils";
import {SiteConfig} from "../../../core/bootstrap/models/site-config";
import {DeviceStore} from "../../../core/app/device.store";
import {CompetitionsFactory} from "./competitions-factory";
import {CompetitionsApi} from "./competitions.api";

export class CompetitionsRepository extends BaseRepository {
  static injectables = [DomUtils, LoggerUtils, SiteConfig, DeviceStore, CompetitionsApi, CompetitionsFactory];
}
